var THREE = require("three");
var UTILS = require("./utils.js");
var v = require("../data/store.js");
var GEOS = require("../libs/geos.js");
var x = new THREE.Vector3();
var y = GEOS.generateCube(null, 1, 1, 1, {});
function z(G) {
  this.mesh = new THREE.Mesh(y);
  this.init = function (H) {
    this.dst = H.dst;
    this.spd = H.spd;
    this.xS = H.xS;
    this.zS = H.zS;
    this.yS = H.yS;
    this.scale = 0.45;
    this.len = 0;
    this.mesh.material = G.getMat("default", {
      mat: THREE.MeshBasicMaterial,
      color: 15592941,
      transparent: true,
      opacity: 0.21,
    });
    var I = H.mesh.position.x;
    var J = H.mesh.position.y;
    var K = H.mesh.position.z;
    G.moveMesh(this.mesh, I, J, K);
    this.mesh.lookAt(I + this.xS, J + this.yS, K + this.zS);
    this.mesh.rotateX(Math.PI / 2);
    G.scaleMesh(this.mesh, this.scale, this.len, this.scale);
    this.mesh.visible = true;
  };
  this.update = function (H) {
    if (this.mesh.visible) {
      if (this.len < this.dst) {
        this.len += this.spd * H;
        if (this.len >= this.dst) {
          this.len = this.dst;
        }
      }
      this.scale -= H * 0.00036;
      G.scaleMesh(this.mesh, this.scale, this.len, this.scale);
      if (this.scale <= 0) {
        this.scale = 0;
        this.mesh.visible = false;
      }
    }
  };
}
function A() {
  THREE.Object3D.call(this);
  this.largeSpawnCount = 8;
  this.smallSpawnCount = 15;
  this.emissiveness = 0.55;
  this.velocityDamping = 3;
  this.lifeSpeedMin = 2.2;
  this.lifeSpeedRange = 3;
  var G = new THREE.Geometry({
    dynamic: true,
  });
  var H = new THREE.Color(12303291);
  this.mesh = new THREE.Mesh(
    G,
    new THREE.StrippedLambertMaterial({
      color: H,
      emissive: H.multiplyScalar(this.emissiveness),
      shading: THREE.SmoothShading,
    }),
  );
  this.mesh.castShadow = true;
  this.mesh.receiveShadow = true;
  this.add(this.mesh);
  this.cubeTemplate = new THREE.BoxGeometry(1, 1, 1);
  for (var I = 0; I < this.cubeTemplate.faces.length; I++) {
    this.cubeTemplate.faces[I].materialIndex = 0;
  }
  this.cubeTemplate.faceVertexUvs = [[]];
  this.entities = [];
}
A.staticMatrix = new THREE.Matrix4();
A.prototype = Object.create(THREE.Object3D.prototype);
Object.defineProperty(A, "finished", function () {
  return this.entities.length === 0;
});
A.prototype.explodeAt = function (G, H, I, J) {
  this.sizeMin = J * 0.35;
  this.sizeRange = J * 1.8;
  this.velocityMin = J * 30;
  this.velocityRange = J * 17;
  x.set(G, H, I);
  for (var K = 0; K < this.largeSpawnCount; K++) {
    this.spawnEntity(Math.random() * 0.1 + 0.9, x, false);
  }
  for (K = 0; K < this.smallSpawnCount; K++) {
    this.spawnEntity(Math.random() * 0.9, x, false);
  }
};
A.prototype.spawnEntity = function (G, H) {
  var I = Math.pow(G, 2.5);
  var J = I * this.sizeRange + this.sizeMin;
  var K = (1 - I) * this.velocityRange + this.velocityMin;
  var L = this._randomVector().normalize().multiplyScalar(K);
  var M = I * this.lifeSpeedRange + this.lifeSpeedMin;
  var N = 0;
  while (true) {
    var O = true;
    for (var P = 0; P < this.entities.length; P++) {
      if (this.entities[P].index === N) {
        O = false;
        break;
      }
    }
    if (O) {
      break;
    }
    N++;
  }
  if (N * 8 > this.mesh.geometry.vertices.length - 1) {
    this.mesh.geometry.merge(this.cubeTemplate, A.emptyMatrix);
  }
  this.entities.push({
    index: N,
    rank: I,
    rankSeed: G,
    life: 0,
    lifeSpeed: M,
    size: J,
    position: H.clone(),
    velocity: L,
  });
};
A.prototype.destroyEntity = function (G) {
  this.entities.splice(this.entities.indexOf(G), 1);
  for (var H = G.index * 8; H < (G.index + 1) * 8; H++) {
    this.mesh.geometry.vertices[H].set(0, 0, 0);
  }
  this.mesh.geometry.verticesNeedUpdate = true;
  this.mesh.geometry.elementsNeedUpdate = true;
  this._cleanGeometry();
};
A.prototype.update = function (G) {
  G /= 1000;
  var H;
  for (var I = 0; I < this.entities.length; I++) {
    (H = this.entities[I]).life += G * H.lifeSpeed;
    H.velocity.multiplyScalar(1 - this.velocityDamping * G);
    H.position.add(H.velocity.clone().multiplyScalar(G));
    var J = 2 - Math.pow(H.life / Math.sqrt(2), 2);
    J *= H.size;
    for (var K = H.index * 8; K < (H.index + 1) * 8; K++) {
      var L = this.mesh.geometry.vertices[K];
      var M = this.cubeTemplate.vertices[K % 8];
      L.set(H.position.x, H.position.y, H.position.z).addScaledVector(M, J);
    }
    if (J <= 0) {
      this.destroyEntity(H);
    }
  }
  this.mesh.geometry.verticesNeedUpdate = true;
  this.mesh.geometry.elementsNeedUpdate = true;
  this.mesh.geometry.computeBoundingSphere();
};
A.prototype._cleanGeometry = function () {
  var G;
  var H = this.mesh.geometry.vertices;
  var I = this.mesh.geometry.faces;
  var J = -1;
  for (var K = 0; K < this.entities.length; K++) {
    if ((G = this.entities[K]).index > J) {
      J = G.index;
    }
  }
  var L = J + 1;
  H.splice(L * 8, H.length - L * 8);
  I.splice(L * 12, I.length - L * 12);
};
A.prototype._randomVector = function () {
  return new THREE.Vector3(
    Math.random() - 0.5,
    Math.random() - 0.5,
    Math.random() - 0.5,
  );
};
var B = [
  {
    rng: 27,
    src: ["whizz_0", "whizz_1"],
    vol: 0.12,
  },
];
var C = [
  {
    mat: THREE.MeshBasicMaterial,
    snd: 0,
    spd: 1.7,
    scale: 1,
    length: 13,
    color: 16777179,
  },
  {
    spd: [0.03, 0.031],
    rand: true,
    carryV: true,
    grav: 0.0003,
    spn: [0.04, 0.05],
    scale: 0.15,
    length: 0.5,
    color: 10124094,
  },
  {
    spd: [0.03, 0.031],
    rand: true,
    carryV: true,
    grav: 0.0003,
    spn: [0.03, 0.05],
    scale: 0.1,
    length: 0.4,
    color: 10124094,
  },
];
function D(G, H) {
  this.meshConf = {
    src: null,
  };
  if (H != null) {
    if (UTILS.isNumber(H)) {
      this.meshConf = UTILS.getMeleeConfig(H, v, THREE);
    } else {
      this.meshConf = {
        src: H,
        transparent: true,
        depthWrite: false,
        blending: 2,
        side: 2,
      };
    }
  }
  if (this.meshConf.src) {
    this.mesh = G.genObj3D(0, 0, 0);
    G.loadMesh(this.meshConf, 0, 0, 0, Math.PI / 2, 1, this.mesh);
  } else {
    this.mesh = new THREE.Mesh(G.cubeGeo);
  }
  this.init = function (I, J, K, L, M, N, O, P) {
    this.dst = N;
    this.scale = O.scale;
    this.spd = O.spd[1] ? UTILS.randFloat(O.spd[0], O.spd[1]) : O.spd;
    var Q = O && O.carryV && P;
    L -= Math.PI;
    this.xS = this.spd * Math.sin(L) * Math.cos(M) + (Q ? P.velX : 0);
    this.zS = this.spd * Math.cos(L) * Math.cos(M) + (Q ? P.velZ : 0);
    this.yS = this.spd * Math.sin(M) + (Q ? P.velY : 0);
    this.grav = O.grav;
    this.lingerTime = O.linger;
    this.lookDir = !!O.lookDir;
    this.spin = O.spn
      ? O.spn[1]
        ? UTILS.randFloat(O.spn[0], O.spn[1])
        : O.spn
      : 0;
    this.sound = P && P.isYou && O.snd != null ? null : B[O.snd];
    this.soundPlayed = false;
    if (!this.meshConf.src) {
      if (O.mat == "BASIC") {
        O.mat = THREE.MeshBasicMaterial;
      }
      this.mesh.receiveShadow = O.mat != THREE.MeshBasicMaterial;
      this.mesh.material = G.getMat("default", {
        fog: O.mat != THREE.MeshBasicMaterial,
        color: O.color,
        emissive: O.emis,
        mat: O.mat,
      });
    }
    this.layer = P && P.renderYou ? 1 : 0;
    G.moveMesh(this.mesh, I, J, K);
    this.mesh.lookAt(I + this.xS, J + this.yS, K + this.zS);
    if (O && O.rand) {
      this.mesh.rotateX(UTILS.randFloat(-Math.PI, Math.PI));
    }
    G.scaleMesh(this.mesh, O.scale, O.scale, O.length);
  };
  this.checkSound = function () {
    if (this.sound && !this.soundPlayed) {
      var I = Howler.pos();
      if (
        UTILS.getD3D(
          I[0],
          I[1],
          I[2],
          this.mesh.position.x,
          this.mesh.position.y,
          this.mesh.position.z,
        ) <= this.sound.rng
      ) {
        SOUND.play(
          this.sound.src[UTILS.randInt(0, this.sound.src.length - 1)],
          this.sound.vol,
          false,
          UTILS.randFloat(0.8, 1.2),
        );
        this.soundPlayed = true;
      }
    }
  };
  this.update = function (I) {
    if (this.mesh.visible) {
      if (this.linger > 0) {
        this.linger -= I;
        if (this.linger <= 0) {
          this.mesh.visible = false;
        }
      } else {
        this.mesh.position.x += this.xS * I;
        this.mesh.position.z += this.zS * I;
        this.mesh.position.y += this.yS * I;
        if (this.spin) {
          this.mesh.rotateX(this.spin * I);
        }
        if (this.grav) {
          this.yS -= (this.grav || 0) * I;
          if (this.lookDir) {
            this.mesh.lookAt(
              this.mesh.position.x + this.xS,
              this.mesh.position.y + this.yS,
              this.mesh.position.z + this.zS,
            );
          }
        }
        this.dst -= this.spd * I;
        this.checkSound();
        if (this.dst <= 0) {
          this.mesh.visible = false;
        }
      }
    }
  };
}
THREE.Sprite.prototype.init = function (G, H, I, J, K) {
  this.position.x = G;
  this.position.y = H;
  this.position.z = I;
  this.velX = J.xV || 0;
  this.velY = J.yV || 0;
  this.oYVel = this.velY;
  this.velZ = J.zV || 0;
  this.startSiz = J.siz || 0;
  this.scale.x = this.scale.y = this.startSiz;
  this.sclSpd = J.scl || 0;
  this.life = J.life || 0;
  this.decl = J.decl || 0;
  this.grav = J.grav || 0;
  this.static = J.static;
  this.dstVis = J.dstVis || 0;
  this.visCountD = 0;
  this.area = K;
  this.updC = 0;
};
THREE.Sprite.prototype.update = function (G, H, I, J) {
  if (H) {
    if (
      (this.area || this.dstVis) &&
      ((this.visCountD -= G), this.visCountD <= 0)
    ) {
      var K = UTILS.getD3D(
        I ? I.x : 0,
        I ? I.y : 0,
        I ? I.z : 0,
        this.position.x,
        this.position.y,
        this.position.z,
      );
      this.visCountD =
        K >= 2000
          ? UTILS.randInt(5000, 7000)
          : K >= 1000
            ? UTILS.randInt(1500, 2500)
            : K >= 400
              ? UTILS.randInt(1000, 1200)
              : UTILS.randInt(500, 600);
      this.visible = K <= J * (this.dstVis || 1);
    }
    if (this.visible || this.area) {
      this.position.x += this.velX * G;
      this.position.z += this.velZ * G;
      this.position.y += this.velY * G;
      this.velY -= this.grav * G;
      this.sclSpd;
      if (this.area) {
        var L = this.scale.x / 2;
        if (this.position.x - L >= this.area.x + this.area.w) {
          this.position.x = this.area.x - this.area.w - L;
        } else if (this.position.x + L <= this.area.x - this.area.w) {
          this.position.x = this.area.x + this.area.w + L;
        }
        if (this.position.z - L >= this.area.z + this.area.l) {
          this.position.z = this.area.z - this.area.l - L;
        } else if (this.position.z + L <= this.area.z - this.area.l) {
          this.position.z = this.area.z + this.area.l + L;
        }
        if (this.position.y - L > this.area.y + this.area.h) {
          this.position.y = this.area.y - L;
          this.velY = this.oYVel;
          this.visible = false;
        } else if (this.position.y + L < this.area.y) {
          this.position.y = this.area.y + this.area.h + L;
          this.velY = this.oYVel;
          this.visible = false;
        }
      }
      if (this.life > 0) {
        this.life -= G;
        if (this.life <= 0 && this.updC) {
          this.visible = false;
        }
        this.updC++;
      } else if (this.life <= 0 && this.updC) {
        this.visible = false;
      }
    }
  } else {
    this.visible = false;
  }
};
var E = [Math.PI / 3, -Math.PI / 3];
var F = [
  {
    src: "0",
    hole: true,
    count: 2,
    grav: -0.00002,
    scale: [5, 9],
    speed: [0, 0.025],
    spread: [-0.4, 0.4],
    life: [300, 500],
  },
  {},
  {
    count: 1,
    blending: 2,
    scale: [5, 7],
    speed: [0, 0],
    spread: [0, 0],
    life: [30, 35],
  },
  {
    count: 1,
    blending: 2,
    scale: [2000, 2000],
    speed: [0, 0],
    spread: [0, 0],
  },
  {
    count: 4,
    src: "0",
    scale: [5, 6],
    speed: [0, 0.01],
    spread: [-1, 1],
    life: [600, 800],
  },
];
module.exports = function (G, H) {
  var I;
  var J;
  var K;
  var L = this;
  this.particles = [];
  this.trails = [];
  this.physObjs = [];
  this.areas = [];
  this.active = true;
  this.partDst = 160;
  this.ExplosionManager = new A();
  this.addTrail = function (M) {
    K = null;
    for (var N = 0; N < this.trails.length; ++N) {
      if (!this.trails[N].mesh.visible) {
        K = this.trails[N];
        break;
      }
    }
    if (!K) {
      K = new z(G);
      this.trails.push(K);
      G.scene.add(K.mesh);
    }
    K.init(M);
  };
  this.area = function (M, N, O, P, Q, R, S, T) {
    P /= 2;
    R /= 2;
    L.areas.push({
      f: T,
      x: M,
      y: N,
      z: O,
      w: P,
      h: Q,
      l: R,
    });
    var U = S.spd * 0.005;
    var V = (((S.dir || 0) + 1) * Math.PI) / 2 - Math.PI / 2;
    var W = H.particleIDS[S.txt || 0] || "default";
    if (W != "default") {
      W += "_0";
    }
    for (var X = 0; X < S.cnt; ++X) {
      L.add(
        M + UTILS.randInt(-P, P),
        N + UTILS.randInt(0, Q),
        O + UTILS.randInt(-R, R),
        {
          src: W,
          cnt: S.cnt,
          static: true,
          xV: U * Math.cos(V),
          zV: U * Math.sin(V),
          grav: (S.grav || 0) * (UTILS.randFloat(0.7, 1.3) * 0.00001),
          decl: S.decl,
          scl: S.scl * UTILS.randFloat(0.75, 1.25),
          siz: S.siz,
          colr: S.colr,
          blend: S.blend,
        },
        this.areas[this.areas.length - 1],
      );
    }
  };
  this.effect = function (M, N, O, P, Q, R) {
    if (this.active) {
      I = F[R];
      for (var S = 0; S < I.count; ++S) {
        var T = UTILS.randFloat(I.speed[0], I.speed[1]);
        var U = P + UTILS.randFloat(I.spread[0], I.spread[1]);
        var V = Q + UTILS.randFloat(I.spread[0], I.spread[1]);
        this.add(M, N, O, {
          src: I.src || 0,
          xV: T * Math.sin(U) * Math.cos(V),
          yV: T * Math.sin(V),
          zV: T * Math.cos(U) * Math.cos(V),
          blend: I.blending,
          grav: I.grav,
          siz: UTILS.randFloat(I.scale[0], I.scale[1]),
          life: I.life ? UTILS.randInt(I.life[0], I.life[1]) : 0,
        });
      }
      if (I.hole) {
        this.add(M, N, O, {
          src: "1",
          blend: THREE.SubtractiveBlending,
          siz: UTILS.randFloat(0.4, 1),
          life: 4000,
        });
      }
    }
  };
  this.add = function (M, N, O, P, Q) {
    J = null;
    for (var R = 0; R < this.particles.length; ++R) {
      if (!this.particles[R].visible && !this.particles[R].static) {
        J = this.particles[R];
        break;
      }
    }
    if (!J) {
      J = new THREE.Sprite();
      this.particles.push(J);
      G.scene.add(J);
    }
    this.setMaterial(J, P.src, P.blend || 0, P.src != "grass_0", P.colr);
    J.visible = true;
    J.init(M, N, O, P, Q);
  };
  this.setMaterial = function (M, N, O, P, Q) {
    M.material = G.getMat("particles/" + N, {
      mat: THREE.SpriteMaterial,
      color: Q == null ? 16777215 : Q,
      depthWrite: false,
      blending: O || THREE.NormalBlending,
      rotation: P ? E[UTILS.randInt(0, 2)] : 0,
    });
  };
  this.physObj = function (M, N, O, P, Q, R, S, T, U, V, W, X, Y) {
    J = null;
    for (var Z = 0; Z < this.physObjs.length; ++Z) {
      if (
        !this.physObjs[Z].mesh.visible &&
        this.physObjs[Z].meshConf.src == Y
      ) {
        J = this.physObjs[Z];
        break;
      }
    }
    if (!J) {
      J = new D(G, Y);
      this.physObjs.push(J);
      G.scene.add(J.mesh);
    }
    J.sid = W == null ? null : W;
    J.owid = X || null;
    J.mesh.visible = true;
    J.init(M, N, O, P, Q, R, V || C[T], U);
    if (S && this.showTrails) {
      this.addTrail(J);
    }
  };
  this.disablePhys = function (M, N, O, P, Q, R) {
    if (N) {
      for (var S = 0; S < this.physObjs.length; ++S) {
        if (this.physObjs[S].owid == M) {
          if (this.physObjs[S].lingerTime && O) {
            G.moveMesh(this.physObjs[S].mesh, P, Q, R);
            this.physObjs[S].mesh.lookAt(
              P - this.physObjs[S].xS,
              Q - this.physObjs[S].yS,
              R - this.physObjs[S].zS,
            );
            this.physObjs[S].linger = this.physObjs[S].lingerTime;
          } else {
            this.physObjs[S].mesh.visible = false;
          }
        }
      }
    } else {
      for (S = 0; S < this.physObjs.length; ++S) {
        if (this.physObjs[S].sid == M) {
          if (this.physObjs[S].lingerTime && O) {
            G.moveMesh(this.physObjs[S].mesh, P, Q, R);
            this.physObjs[S].mesh.lookAt(
              P - this.physObjs[S].xS,
              Q - this.physObjs[S].yS,
              R - this.physObjs[S].zS,
            );
            this.physObjs[S].linger = this.physObjs[S].lingerTime;
          } else {
            this.physObjs[S].mesh.visible = false;
          }
        }
      }
    }
  };
  this.update = function (M, N) {
    if (N && N.active) {
      for (var O = 0; O < this.areas.length; ++O) {
        if (this.areas[O].f) {
          this.areas[O].x = N.x;
          this.areas[O].y = N.y;
          this.areas[O].z = N.z;
        }
      }
    }
    for (O = 0; O < this.trails.length; ++O) {
      this.trails[O].update(M);
    }
    for (O = 0; O < this.particles.length; ++O) {
      this.particles[O].update(M, this.active, N, this.partDst);
    }
    for (O = 0; O < this.physObjs.length; ++O) {
      this.physObjs[O].update(M);
    }
    this.ExplosionManager.update(M);
  };
  this.reset = function () {
    this.particles.length = 0;
    this.trails.length = 0;
    this.physObjs.length = 0;
    this.areas.length = 0;
  };
  this.setTracerColor = function (M) {
    C[0].color = M;
  };
};
